<template>
  <div class="col-12">
    <ul class="nav nav-tabs">
      <li v-for="tab in adminTabs" :key="tab" class="nav-item">
        <a
          :class="{ active: active_admin_tab === tab }"
          class="nav-link"
          data-toggle="tab"
          href="#"
          @click="active_admin_tab = tab"
        >
          {{ tab }}
        </a>
      </li>
    </ul>
    <div>
      <projects-table
        v-show="active_admin_tab === 'Projects'"
        :projects="projects"
        :showSearchBar="false"
      />
    </div>
    <!-- Invoices Card -->
    <div v-show="active_admin_tab === 'Invoices'" class="card">
      <div class="card-body">
        <div class="col-12 overflow-auto">
          <search-results-table
            v-if="adminInvoicesResult"
            v-model="adminInvoicesResult"
            class="mt-4"
          />
        </div>
      </div>
    </div>

    <!-- Quotes Card -->
    <div v-show="active_admin_tab === 'Quotes'" class="card">
      <div class="card-body">
        <div class="col-12 overflow-auto">
          <search-results-table
            v-if="quotesResult"
            v-model="quotesResult"
            class="mt-4"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getVesselProjects } from "@/apis/vessels";
import ProjectsTable from "../../../projects/ProjectsTable.vue";
import { getInvoicesReport } from "@/apis/projects";
import { notifyError } from "@/helpers/notification";
import SearchResultsTable from "../../../../pages/search/SearchResultsTable.vue";

export default {
  name: "AdminTab",
  components: { ProjectsTable, SearchResultsTable },
  props: {
    vessel: Object,
  },
  data() {
    return {
      projects: [],
      adminTabs: ["Projects", "Invoices", "Quotes"],
      active_admin_tab: "Projects",
      adminInvoicesResult: null,
      quotesResult: [],
    };
  },
  methods: {
    async loadInvoiceReports() {
      const projectIds = this.projects?.map((proj) => proj.id)?.toString();
      if (!projectIds) {
        this.adminInvoicesResult = [];
        return;
      }
      getInvoicesReport({ projectIds })
        .then((response) => {
          this.adminInvoicesResult = response?.data;
        })
        .catch((err) => {
          notifyError(this, err?.response?.data);
        });
    },
  },
  watch: {
    active_admin_tab: {
      handler() {
        if (!this.adminInvoicesResult && this.active_admin_tab === "Invoices")
          this.loadInvoiceReports();
      },
    },
  },
  mounted() {
    if (!this.vessel) return;
    getVesselProjects(this.vessel.id).then(
      (data) => (this.projects = data.data)
    );
  },
};
</script>
